import { toRefs, reactive, onMounted } from 'vue';
const layoutConfig = reactive({
    isDarkTheme: false,
    favoritesPages: [],
});

export function useLayout() {
    const { $localStorage } = useNuxtApp();

    if ($localStorage.getItem('isDarkTheme') === 'true') {
        document.documentElement.classList.add('dark');
    }

    layoutConfig.isDarkTheme = $localStorage.getItem('isDarkTheme') === 'true';
    layoutConfig.favoritesPages = JSON.parse($localStorage.getItem('favorites') || null) || [];

    const onDarkModeChange = () => {
        document.documentElement.classList.toggle('dark');
        const isDark = document.documentElement.classList.contains('dark');

        layoutConfig.isDarkTheme = isDark;
        $localStorage.setItem('isDarkTheme', isDark);
    };

    const onAddFavoritePage = (pages) => {
        layoutConfig.favoritesPages = JSON.parse(pages || null) || [];
    };

    onMounted(() => {
        if (layoutConfig.isDarkTheme) {
            document.documentElement.classList.add('dark');
        }
    });

    const refs = toRefs(layoutConfig);
    return {
        layoutConfig: refs,
        isDarkTheme: refs.isDarkTheme,
        favoritesPages: refs.favoritesPages,
        onDarkModeChange,
        onAddFavoritePage,
    };
}
